const drawerWidth = 200;

export const useStyles = (theme) => ({
  root: {
    marginLeft: drawerWidth,
    minHeight: "90vh",
    padding: 30,
    marginTop: 50,
    backgroundColor: "#f9f9fc",
    [theme.breakpoints.down("md")]: {
      marginLeft: "auto",
      marginRight: "auto",
      padding: 20,
    },
  },
  gridContainer: {
    display: "flex",
    flexDirection: "row",
    padding: 20,
  },
  loadingStyle: {
    height: "90vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  buttonStyle: {
    background: "#0a1f3a !important",
    outlineColor: "#0a1f3a !important",
    color: "#ffffff",
    fontSize: 18,
    borderRadius: 20,
    textTransform: "none",
    marginRight: 10,
    "&:hover": {
      backgroundColor: "#eee !important",
      borderColor: "#0a1f3a !important",
      color: "#181818",
    },
  },
  tooltip: {
    "&:hover": {
      cursor: "pointer",
      textDecoration: "underline",
    },
  },
});
